import { PRODUCTION, DEVELOPMENT, LOCAL_PRODUCT_MASTER_URL } from "./const";
import { isEmpty } from "lodash";

function productMasterURL() {
  const REACT_ENV = import.meta.env.VITE_HOST_ENV;
  const PRODUCT_MASTER_URL = !!import.meta.env.VITE_PRODUCT_MASTER_URL && import.meta.env.VITE_PRODUCT_MASTER_URL !== "" ? import.meta.env.VITE_PRODUCT_MASTER_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return PRODUCT_MASTER_URL;
      case PRODUCTION:
        return PRODUCT_MASTER_URL;
      default:
        return LOCAL_PRODUCT_MASTER_URL;
    }
  } else {
    return LOCAL_PRODUCT_MASTER_URL;
  }
}

export const getProductMasterURL = () => {
  return `${productMasterURL()}`;
};
